import { LayoutContainer } from '@pendwa/common-browser/components/LayoutContainer/index.js';
import { LayoutPageSection } from '@pendwa/common-browser/components/LayoutPageSection/index.js';
import { Footer } from '@pendwa/common-browser/components/Navs/Footer/index.js';
import { Nav } from '@pendwa/common-browser/components/Navs/Nav/index.js';
import { NotFound } from '@pendwa/common-browser/components/NotFound/index.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { getFooterConfig } from '../../../core/footer/config/index.js';
import { getNavConfig } from '../../../core/nav/config/index.js';

export function Screen() {
  return (
    <>
      <Nav getConfig={getNavConfig} />

      <LayoutPageSection>
        <LayoutContainer>
          <NotFound
            back={{
              to: rootRoutes.sc.main.get(),
              label: `Back To ${browserRootConfig.project.name}`,
            }}
          />
        </LayoutContainer>
      </LayoutPageSection>

      <LayoutPageSection className={'mt-32'}>
        <LayoutContainer>
          <Footer getConfig={getFooterConfig} />
        </LayoutContainer>
      </LayoutPageSection>
    </>
  );
}
